<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <form @submit.prevent="TrainingForm" style="height:100vh">
                <div class="container-fluid mt-5">
                    <div class="col-sm-12">
                        <div class="row dblock" style="padding: 5px;">
                            <div class="row">
                                <div class="col-md-12">
                                    <vs-breadcrumb align="left" :items="
                      [
                        {title: 'You are here : '},
                        {
                          title: 'Dashboard',
                          url: '/#/dashboard/program-officer/todoList'
                        },
                        {
                          title: this.updateTraining.title,
                          url: '/#/dashboard/program-officer/todoList'
                        },
                        {
                          title: 'Update Training',
                          active: true
                        }
                      ]
                        "></vs-breadcrumb>
                                    <div class="heading">
                                        <h3 class="text-secondary">TRAINING FORM</h3>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-sm-12 p-0 mb-4">
                  <span style="font-weight:bold">
                    Form Complete : 20%
                    <vs-progress :percent="20" color="primary">primary</vs-progress>
                  </span>
                </div>-->
                            <vs-tabs alignment="fixed">
                                <vs-tab label="Event Information ">
                                    <div>
                                        <div class="form-group form-row text-dark mt-4">
                                            <h6 class="sub-frm-title">Event Information</h6>
                                            <div class="row col-sm-12">
                                                <label class="col-sm-1 font-weight-bold">Title:</label>
                                                <div class="col-sm-11">{{updateTraining.title}}</div>
                                            </div>
                                        </div>
                                        <div class="form-group form-row">
                                            <h6 class="sub-frm-title">Event Information</h6>
                                            <div class="row col-md-12 col-lg-12" style="margin-bottom:150px">
                                                <div class="col-md-12 col-lg-12 mt-4">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="updateTraining.subprogram.title" type="text" disabled placeholder=" " />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                        </span>
                                                        <label class="lbl-label">Sub Program</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 col-lg-12 mt-4">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="updateTraining.project.title" type="text" disabled placeholder=" " />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                        </span>
                                                        <label class="lbl-label">Project Title</label>
                                                    </div>
                                                </div>
                                                <!-- </div> -->
                                                <div class="col-md-12 col-lg-12 mt-3">
                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">Donor Name</label>
                                                    <selectize id="select-state" disabled v-model="donerSelected" :settings="donersettings">
                                                        <option v-for="(item,index) in selectedDoner" :key="index" :value="item.id" disabled>
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>

                                                <div class="col-md-12 col-lg-12 mt-3">
                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">
                                                        Department
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state" v-model="department" :settings="departmentsettings">
                                                        <option v-for="(item,index) in departmentArr" :key="index" :value="item.id">
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                                <div class="col-md-12 col-lg-12 mt-4">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="updateTraining.title" type="text" disabled placeholder=" " />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                        </span>
                                                        <label class="lbl-label">Training Title</label>
                                                    </div>
                                                </div>

                                                <div class="col-md-6 col-lg-6 mt-3">
                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">
                                                        Training Type
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <selectize id="select-state" v-model="type_training" :searchable="true">
                                                        <option v-for="(item,index) in trainingTypeArr" :key="index" :value="item.id" :text="item.title">
                                                            {{item.title}}
                                                        </option>
                                                    </selectize>
                                                </div>
                                                <div class="col-md-6 col-lg-6 mt-3">
                                                    <label for class="vs-input--label" style="color: #07a7e19c !important;">
                                                        Date Range
                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                    </label>
                                                    <flat-pickr class="form-control" style="background: #fff" placeholder="Start date Range" v-model="dateRange" :config="dateOptions"></flat-pickr>
                                                </div>
                                                <div class="col-md-12 col-lg-12 mt-4">
                                                    <div class="floating-label">
                                                        <input class="floating-input form-control" v-model="noOfDays" type="text" disabled placeholder=" " />

                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                        </span>
                                                        <label class="lbl-label">No Of Days</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </vs-tab>
                                <vs-tab label="Training Locations">
                                    <div>
                                        <div class="form-row mt-4">
                                            <h6 class="sub-frm-title">Training Location(s)</h6>
                                            <div class="col-md-12 col-lg-12">
                                                <b-button v-if="!isForm" @click="isForm = true" class="add-locations-btn" variant="primary">Add Training location(s)</b-button>
                                                <b-card v-if="isForm" style="background-color:#f9f9f9;border: 1px dotted #07a7e14f;">
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">
                                                                        Country
                                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                    </label>
                                                                    <selectize id="select-state" v-model="country">
                                                                        <option v-for="(item,index) in countryArr" :key="index" :value="item.id">
                                                                            {{item.title}}
                                                                        </option>
                                                                    </selectize>
                                                                </div>
                                                                <div class="col-md-4 col-lg-4">
                                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">
                                                                        Province
                                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                    </label>
                                                                    <selectize id="select-state" v-model="province">
                                                                        <option v-for="(item,index) in provinceArr" :key="index" :value="item.id">
                                                                            {{item.title}}
                                                                        </option>
                                                                    </selectize>
                                                                </div>

                                                                <div class="col-md-4 col-lg-4">
                                                                    <label style="padding-left: 5px;font-size:.85rem;color: #07a7e19c !important;">
                                                                        City
                                                                        <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                    </label>
                                                                    <selectize id="select-state" v-model="district">
                                                                        <option v-for="(item,index) in cityArr" :key="index" :value="item.id">
                                                                            {{item.title}}
                                                                        </option>
                                                                    </selectize>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <div class="col-md-4 col-lg-4" style="margin-top:10px;">
                                                                    <div class="floating-label">
                                                                        <input class="floating-input form-control" v-model="contact_person" type="text" placeholder=" " />

                                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                            <i class="material-icons" style="font-size: 20px;">account_circle</i>
                                                                        </span>
                                                                        <label class="lbl-label">
                                                                            Contact Person Name
                                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <!-- floating input ends -->

                                                                <!-- floating input starts -->
                                                                <div class="col-md-4 col-lg-4" style="margin-top:10px;">
                                                                    <div class="floating-label">
                                                                        <input class="floating-input form-control" v-model="contact_number" type="text" v-mask="'(9999) 9999999'" placeholder=" " />

                                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                            <i class="material-icons" style="font-size: 20px;">call</i>
                                                                        </span>
                                                                        <label class="lbl-label">
                                                                            Contact Number
                                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <!-- floating input ends -->

                                                                <!-- floating input starts -->
                                                                <div class="col-md-4 col-lg-4" style="margin-top:10px;">
                                                                    <div class="floating-label">
                                                                        <input class="floating-input form-control" v-model="contact_email" type="email" placeholder=" " />

                                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                            <i class="material-icons" style="font-size: 20px;">email</i>
                                                                        </span>
                                                                        <label class="lbl-label">
                                                                            Email
                                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <!-- floating input ends -->
                                                                <!-- email ends -->
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="row">
                                                                <!-- floating input starts -->
                                                                <div class="col-md-8 col-lg-8" style="margin-top:10px;">
                                                                    <div class="floating-label">
                                                                        <input class="floating-input form-control" v-model="address" type="text" placeholder=" " />

                                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                            <i class="material-icons" style="font-size: 20px;">place</i>
                                                                        </span>
                                                                        <label class="lbl-label">
                                                                            Address
                                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <!-- floating input ends -->
                                                                <!-- Address Ends -->
                                                                <!-- floating input starts -->
                                                                <div class="col-md-8 col-lg-8" style="margin-top:10px;">
                                                                    <div class="floating-label">
                                                                        <input class="floating-input form-control" v-model="venue" type="text" placeholder=" " />

                                                                        <span class="lbl-label" style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;">
                                                                            <i class="material-icons" style="font-size: 20px;">account_balance</i>
                                                                        </span>
                                                                        <label class="lbl-label">
                                                                            Venue
                                                                            <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <!-- floating input ends -->
                                                                <div class="col-sm-4">
                                                                    <!-- add button starts-->
                                                                    <b-button class="save-btn" type="submit" variant="primary">Add</b-button>
                                                                    <!-- add button ends -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-card>
                                            </div>
                                            <!-- <div class="col-md-12 col-lg-12">

                          <b-card>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-md-12 col-md-lg">
                                  <b-table show-empty outlined :items="items" :fields="fields">
                                    <template slot="actions">
                                      <vs-icon
                                        class="mr-4"
                                        icon="edit"
                                        style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                      ></vs-icon>
                                      <vs-icon
                                        class="mr-1"
                                        icon="delete_forever"
                                        style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                      ></vs-icon>
                                    </template>
                                  </b-table>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </div>-->
                                        </div>
                                        <div class="form-row mt-4">
                                            <div class="col-sm-12">
                                                <!-- new form popup starts -->
                                                <b-card v-if="createdTrainingss !=''">
                                                    <div class="form-group">
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <div class="table-responsive">
                                                                    <table class="table table-hover">
                                                                        <tr>
                                                                            <th>Sr#</th>
                                                                            <th>Event Title</th>
                                                                            <th>Status</th>
                                                                            <th>Contact Person</th>
                                                                            <th>Contact Number</th>
                                                                            <th>Start Date</th>
                                                                            <th>End Date</th>
                                                                            <th>Address</th>
                                                                            <th>Venue</th>
                                                                        </tr>
                                                                        <tr>
                                                                            <td class="text-capitalize">1</td>
                                                                            <td>{{createdTrainingss.title}}</td>

                                                                            <td>
                                                                                {{createdTrainingss.trainingstatus}}
                                                                            </td>
                                                                            <td>
                                                                                {{createdTrainingss.contact_person}}
                                                                            </td>
                                                                            <td>
                                                                                {{createdTrainingss.contact_number}}
                                                                            </td>
                                                                            <td>{{createdTrainingss.startdate}}</td>
                                                                            <td>{{createdTrainingss.enddate}}</td>
                                                                            <td>{{createdTrainingss.address}}</td>
                                                                            <td>{{createdTrainingss.venue}}</td>
                                                                        </tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-card>
                                                <!-- new form popup ends -->
                                            </div>
                                        </div>
                                    </div>
                                </vs-tab>
                            </vs-tabs>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";
import Selectize from "vue2-selectize";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
    data: () => ({
        inValid: [],
        updateTraining: "",
        donernameArr: [],
        departmentArr: [],
        dateRange: [],
        dateOptions: {
            wrap: true,
            weekNumbers: true,
            mode: "range",
            maxDate: new Date().fp_incr(10),
            dateFormat: "d-m-Y"
        },
        // subprogramArr: [],
        isSidebar: false,
        isForm: true,
        isFormData: false,
        selected: "",
        subprogramSelected: "",
        project_title: "",

        subprogramsettings: {
            maxItems: 3,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        departmentsettings: {
            maxItems: 10,
            plugins: ["remove_button"],
            delimiter: "|"
        },
        donerSelected: [],
        donersettings: {
            maxItems: 5,
            plugins: ["remove_button"],
            delimiter: "|"
        }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md

        contact_person: "",
        trainingId: "",
        trainingCode: "",
        contact_number: "",
        contact_email: "",
        address: "",
        options: {
            format: "DD/MM/YYYY",
            useCurrent: false
        },
        textarea: "",
        venue: "",
        counterDanger: false,
        mydate: "",
        startDate: "",
        agendasArray: [],
        agendasArraySecond: [],
        agendasArrayThird: [],
        newArr: [],
        newArrSecond: [],
        newArrThird: [],
        endDate: "",

        trainingCheck: false,
        repeatedCheck: false,
        selectedDoner: [],
        select1Normal: "",
        training_title: "",
        select2: 1,
        select3: 1,
        type_training: "",
        country: 1,
        province: 1,
        district: 1,
        department: [],
        // project_title: 1,
        trainingtitleArr: [],
        projecttitleArr: [],

        trainingTypeArr: [],
        countryArr: [],
        provinceArr: [],
        cityArr: [],
        createdTrainingss: "",
        isDataEdit: 0,
        items: [],
        fields: []
    }),
    watch: {
        dateRange(date) {
            this.startDate = date.split(" to")[0];
            this.endDate = date.split("to ")[1];
            this.isDataEdit++;
            if (this.isDataEdit > 1) {
                let daysLengthTotal;
                this.startDate = date.split(" to")[0];
                this.endDate = date.split("to ")[1];
                if (date.includes("to")) {
                    let daysInRange = document.getElementsByClassName("inRange");
                    if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
                        daysLengthTotal = daysInRange.length + 2;
                    } else {
                        daysLengthTotal = daysInRange.length + 1;
                    }
                    this.noOfDays = daysLengthTotal;
                }
            }

        },
        country(val) {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/provinces/get/" + val)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.provinceArr = response.data;
                });
        },
        province(val) {
            this.openLoading();
            axios
                .get(process.env.VUE_APP_BASE_PATH + "/districts/get/" + val)
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.cityArr = response.data;
                });
        }
    },
    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;

        // Set the initial number of items
        this.totalRows = this.items.length;

        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/countries/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.countryArr = response.data;
                // this.provinceArr=response.data;
            });
        //select all provinces
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/provinces/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.provinceArr = response.data;
            });
        //select all district
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/districts/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.cityArr = response.data;
            });
        //select all department

        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/departments/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.departmentArr = response.data;
            });
        //select all training type
        this.openLoading();
        axios
            .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingTypeArr = response.data;
            });

        this.allTrainings();
        //show all training drop down data
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.training.id;
                if (response.data && response.data.training) {
                    this.createdTrainingss = response.data.training
                    this.updateTraining = response.data.training;
                }

                this.selectedDoner = response.data.doner;
                response.data.doner.forEach(dnr => {
                    this.donerSelected.push(dnr.id);
                });
                if (response.data.training.typetraining_id != null) {
                    this.type_training = response.data.training.typetraining_id;
                }
                if (
                    response.data.training != undefined &&
                    response.data.training != null &&
                    response.data.training.noofdays
                ) {
                    this.noOfDays = response.data.training.noofdays;
                }
                if (
                    response.data.training.startdate != null &&
                    response.data.training.enddate != null
                ) {
                    this.dateRange =
                        response.data.training.startdate +
                        " to " +
                        response.data.training.enddate;
                }

                if (response.data.training.district.province.country.id != null) {
                    this.country = response.data.training.district.province.country.id;
                }
                if (response.data.training.district.province.id != null) {
                    this.province = response.data.training.district.province.id;
                }
                if (response.data.training.district_id != null) {
                    this.district = response.data.training.district_id;
                }
                if (response.data.training.contact_person != null) {
                    this.contact_person = response.data.training.contact_person;
                }
                if (response.data.training.contact_number != null) {
                    this.contact_number = response.data.training.contact_number;
                }
                if (response.data.training.email != null) {
                    this.contact_email = response.data.training.email;
                }
                if (response.data.training.address != null) {
                    this.address = response.data.training.address;
                }
                if (response.data.training.venue != null) {
                    this.venue = response.data.training.venue;
                }

                if (response.data.departments && response.data.departments != "") {
                    response.data.departments.forEach(department => {
                        this.department.push(department.id);
                    });
                }
                // this.type_training = response.data.trainingtype.title;
            });
    },
    components: {
        Selectize,
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        flatPickr
    },

    methods: {
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        //function used to show all records in table
        allTrainings: function allTrainings() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/selectTable/training/get/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    this.items = response.data;
                });
        },
        showinputvalue: function (event) {
            this.name = event.target.value;
        },
        TrainingForm(e) {
            e.preventDefault();
            this.inValid = [];
            if (!this.startDate) {
                this.inValid.push("Start date is required.");
            }
            if (!this.endDate) {
                this.inValid.push("End date is required.");
            }
            if (!this.department || this.department.length < 1) {
                this.inValid.push("Department is required.");
            }
            if (!this.country) {
                this.inValid.push("Country is required.");
            }
            if (!this.province) {
                this.inValid.push("Province is required.");
            }
            if (!this.district) {
                this.inValid.push("District is required.");
            }
            if (!this.contact_person) {
                this.inValid.push("Contact Person is required.");
            }
            if (!this.contact_number) {
                this.inValid.push("Contact Number is required.");
            }
            if (!this.contact_email) {
                this.inValid.push("Contact Email is required.");
            }
            if (!this.address) {
                this.inValid.push("Address is required.");
            }
            if (!this.venue) {
                this.inValid.push("Venue is required.");
            }
            //For phone number validation
            var phone_no = this.contact_number;
            phone_no = phone_no.replace(/_/g, "");
            if (phone_no.length < 14) {
                this.inValid.push("Must be valid Number, 0345-9992229");
            }

            for (var i = 0; i < this.inValid.length; i++) {
                this.$toasted.global.errorMsg(this.inValid[i]);
            }
            if (!this.inValid.length) {
                // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
                let self = this;
                // let noAccess = '';
                this.openLoading();
                axios
                    .post(
                        process.env.VUE_APP_BASE_PATH + "/register/update/training", {
                            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                            trainingId: this.trainingId,
                            department: JSON.stringify(this.department),
                            type_training: this.type_training,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            district: this.district,
                            contact_person: this.contact_person,
                            contact_number: this.contact_number,
                            contact_email: this.contact_email,
                            address: this.address,
                            venue: this.venue,
                            noOfDays: this.noOfDays
                        }
                    )
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Record has been updated successfully!");
                            self.resetForm();
                            self.allTrainings();
                            this.$router.push({
                                name: "AgendaForm",
                                query: {
                                    trainingId: this.trainingCode
                                }
                            });
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.toastError(error);
                    });
            }
        },
        resetForm() {
            this.department_name = "";
            this.type_training = "";
            this.contact_email = "";
            this.address = "";
            this.contact_person = "";
            this.contact_number = "";
            this.venue = "";
        }
    }
};
</script>

<style scoped>
label.vs-select--label {
    color: #07a7e19c !important;
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary:hover {
    /* color: rgba(var(--vs-primary),1)!important; */
    color: #07a7e19c !important;
}

.vs-select--input {
    color: #343a40 !important;
}

i.vs-icon.notranslate.icon-scale.icon-select.vs-select--icon.material-icons.null {
    color: #343a40 !important;
}
</style><style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.dblock {
    display: block !important;
}

.input-color {
    margin-bottom: 10px;
    position: relative;
    display: block;
}

.myNavbar {
    color: rgb(255, 255, 255);
}

.dflex {
    display: flex;
}

.fcenter {
    justify-content: center;
    align-items: center;
}

.pleft-5 {
    margin-left: 5px;
}

.selectExample {
    margin: 10px;
}

.con-select-example {
    display: flex;
    align-items: center;
    justify-content: center;
}

.con-select .vs-select {
    width: 100%;
}

@media (max-width: 550px) {
    .con-select {
        flex-direction: column;
    }

    .con-select .vs-select {
        width: 100%;
    }
}

.form-row {
    padding: 8px;
    color: #1465a3;
    border: 1px dotted #07a7e14f;
    margin-left: 0px !important;
    margin-right: 0px !important;
}

.field {
    width: 100%;
    text-transform: capitalize;
    border-bottom: 2px solid #d0d0d0;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    transition: all 0.2s ease-in-out 0.2s;
    -webkit-transition: all 0.2s ease-in-out 0.2s;
    -moz-transition: all 0.2s ease-in-out 0.2s;
}

.sub-frm-title {
    padding: 5px;
    background-color: #fff;
    margin-top: -25px;
    text-align: center;
    color: rgba(7, 167, 225, 0.61);
}

/* overide css of vuesax */
.vs-con-input-label {
    width: 100% !important;
}

.vs-con-input-label.is-label-placeholder {
    margin-top: 8px !important;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.save-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    float: right;
    margin: 10px 0px;
}

.add-locations-btn {
    box-shadow: none;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
    margin: 10px 0px;
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show>.btn-primary.dropdown-toggle {
    color: #fff;
    border-color: rgba(7, 167, 225, 0.61);
    background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
    padding-right: 10px;
}

.title-text {
    margin-bottom: 0px;
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
    position: relative;
    margin-bottom: 5px;
}

.floating-input,
.floating-select {
    font-size: 14px;
    padding: 4px 30px 4px 5px;
    display: block;
    width: 100%;
    height: 36px;
    box-shadow: none !important;
    /* background-color: transparent; */
    border: none;
    border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
    outline: none;
    border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
    color: #ccc;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 5px;
    top: 6px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.floating-input:focus~label.lbl-label,
.floating-input:not(:placeholder-shown)~label.lbl-label {
    background-color: #f9f9f9;
    /* background-color: #fff; */
    top: -12px;
    left: 10px;
    font-size: 14px;
    color: rgba(7, 167, 225, 0.61);
    padding: 0px 5px;
}

.floating-select:focus~llabel.lbl-label,
.floating-select:not([value=""]):valid~label.lbl-label {
    top: -18px;
    font-size: 14px;
    color: #5264ae;
}

/* active state */
.floating-input:focus~.bar:before,
.floating-input:focus~.bar:after,
.floating-select:focus~.bar:before,
.floating-select:focus~.bar:after {
    width: 50%;
}

*,
*:before,
*:after {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus~.highlight,
.floating-select:focus~.highlight {
    -webkit-animation: inputHighlighter 0.3s ease;
    -moz-animation: inputHighlighter 0.3s ease;
    animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@-moz-keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}

@keyframes inputHighlighter {
    from {
        background: #5264ae;
    }

    to {
        width: 0;
        background: transparent;
    }
}
</style>
